<template>
    <section v-if="currentBrokerage">
        <div class="grid fixed fixed-max-sm middle xs-grid-cols-1 sm-grid-cols-2">
            <div class="text-center wrap">
                <h2 class="f3 text-bold"> Our Office Location</h2>
            </div>
            <template v-if="currentBrokerage">
                <div class="panel-card large vertical text-center wrap">
                    <div class="img bg">
                        <img loading="lazy" :src="glb.cdnUrl + 'images/desktop/home/cities/' + currentBrokerage.image.sm" :alt="currentBrokerage.image.alt"/>
                    </div>
                    <h3 class="f3 text-white text-bold">{{ currentBrokerage.displayName }}</h3>
                    <a class="btn secondary regular width-fixed" :href="glb.appUrl + currentBrokerage.url">Learn More</a>
                </div>
            </template>
            <template v-else>
                <div class="panel-card large vertical text-center" v-for="city in brokerageInfo">
                    <div class="img bg">
                        <img loading="lazy" :src="glb.cdnUrl + 'images/desktop/home/cities/' + city.image.xs" :alt="city.image.alt"/>
                    </div>
                    <h3 class="f3 text-white text-bold">{{ city.displayName }}</h3>
                    <a class="btn secondary regular" :href="glb.appUrl + city.url">Learn More</a>
                </div>
            </template>
        </div>
    </section>
</template>
<script src="./agent-brokerage.js"></script>